/** Centralized backend endpoint paths (relative to BASE_URL). */
export const ApiEndPoints = {
  // Auth
  access: {
    login: 'access/login',
    googleLogin: 'access/google-login',
    me: 'access/me',
  },

  // Roles & permissions
  role: 'access/role',
  permission: 'access/permission',
  rolePermission: 'access/role-permission',

  // Users
  users: 'access/users',
  team: 'access/team',
  usersImportTemplate: 'access/users/import-template',
  usersImport: 'access/users/import',
  organizationNode: 'organisation/node',
  designations: 'access/users/field_options',

  // Administrative Level Directory (admin officials)
  adminOfficial: 'admin-official',
  adminOfficialFilters: 'admin-official/filters',
  adminOfficialImportTemplate: 'admin-official/import-template',
  adminOfficialImport: 'admin-official/import',

  // Engagements (user flow)
  engagement: 'engagement',
  usersInArea: 'organisation/users-in-area',
  nodeUsers: 'organisation/node-users',

  // Tasks & subtasks (nested under an engagement)
  task: 'task',

  // Daily directions (user flow)
  dailyDirection: 'daily-direction',
  dailyDirectionStats: 'daily-direction/stats',
  referencePersons: 'reference-persons',

  // Citizen requests (user flow)
  citizenRequest: 'citizen-request',
  citizenRequestStats: 'citizen-request/stats',
  citizenRequestReferenceSearch: 'citizen-request/reference-search',
  // AI Engagement Planner (interview -> plan -> apply)
  aiPlan: 'ai/plan',

  // File upload (backend proxies to S3 and returns the stored URL)
  uploadS3: 'upload/s3',

  // Activity — comments, attachments, assignees & change log for an entity (Task, DailyDirection…)
  activityComment: 'activity/comment',
  activityAttachment: 'activity/attachment',
  activityAssignee: 'activity/assignee',
  activityLog: 'activity/log',

  // Organizations
  organization: 'organisation/organization',
  organizationEcScope: 'organisation/organization-ec-scope',
  organizationEcScopeBulk: 'organisation/organization-ec-scope/bulk',
  organizationLevel: 'organisation/level',
  organizationLevelBulk: 'organisation/level/bulk',
  organizationHierarchyTemplate: 'organisation/hierarchy/template',
  organizationHierarchyUpload: 'organisation/hierarchy/upload',
  organizationHierarchyExport: 'organisation/hierarchy/export',
  organizationNodeTree: 'organisation/node/tree',
  organizationNodeMyTree: 'organisation/node/my-tree',
  organizationNodeArea: 'organisation/node-area',
  organizationNodeAreaMap: 'organisation/node-area-map',
  organizationBoundary: 'organisation/boundary',

  // Territory (location hierarchy — loaded lazily, level by level)
  territory: {
    ecLevel: 'territory/ec-level',
    state: 'territory/state',
    parliament: 'territory/parliament',
    district: 'territory/district',
    assembly: 'territory/assembly',
    booth: 'territory/booth',
    gramPanchayat: 'territory/gram-panchayat',
    village: 'territory/village',
    psVillageMap: 'territory/ps-village-map',
    boothInfo: 'territory/booth-info',
    areaInfo: 'territory/area-info',
    ecTree: 'territory/ec-tree',
    locationTree: 'territory/location-tree',
    blockUlb: 'territory/block-ulb',
    ward: 'territory/ward',
  },
} as const;
